import React from "react";

const DataList = (props) => {
  return (
    <div
      className="deposit-compare-container"
      style={{ direction: "rtl" }}
    >
      <div className="deposit-compare-columns">
        {props.dataList.map((list, idx) => {
          return (
            <div key={idx} className="deposit-compare-column">
              {list.title && (
                <div className="deposit-compare-header">{list.title}</div>
              )}
              {list.items.map((item, itemIdx) => {
                return (
                  <div key={itemIdx} className="deposit-compare-row">
                    <div className="deposit-compare-label">{item.label}</div>
                    <div className="deposit-compare-value">
                      {item.value || ' '}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DataList;
